export const QUERY_KEYS = {
  ADDRESS: 'address',
  MY_SELECTIONS: 'mySelections',
  MY_MINI_LEAGUES: 'miniLeagues',
  GAME_USER_SELECTIONS: 'gameUserSelections',
  GAME_SELECTIONS_BY_MATCH: 'gameSelectionsByMatch',
  GAME_PREDICTIONS: 'gamePredictions',
  GAME_RESULTS: 'gameResults',
  GAME_INFO: 'gameInfo',
  POP_UP_DATA: 'popUpData',
  GAME_STATS: 'gameStats',
  UPDATE_PROFILE: 'updateProfile',
  SITE_CONTENT: 'siteContent',
  SCORE_WORDING: 'scoreWording',
  CREATE_MINI_LEAGUE: 'createMiniLeague',
  EDIT_MINI_LEAGUE: 'editMiniLeague',
  USER_INFO: 'userInfo',
  USER_EMAIL: 'userEmail',
  GAME_LEADERBOARD: 'gameLeaderboard',
  GAME_LEADERBOARD_WITH_CELEBRITIES: 'gameLeaderboardWithCelebrities',
  POSITION_DATA: 'positionData',
  RESET: 'reset',
  ROUND: 'round',
  GAME_ROUNDS: 'gameRounds',
  GOLF_LIVE_DATA: 'golfLiveData',
  USER_PREFERENCES: 'userPreferences',
  ADDITIONAL_QUESTION: 'additionalQuestion',
  FREE_ENTRIES: 'freeEntries',
  WALLET_BALANCE: 'walletBalance',
  WALLET_TRANSACTIONS: 'walletTransactions',
  RAFFLE: 'raffle',
  RAFFLE_PRIZES: 'rafflePrizes',
  RAFFLE_TICKETS: 'raffleTickets',
  SPEND_LIMIT: 'spendLimit',
  USER_DETAILS: 'userDetails',
  RECENT_WINNERS: 'recentWinners',
  AFFILIATE_ME: 'affiliateMe',
  AFFILIATE_REF: 'affiliateRef',
  AFFILIATE_LINK_TARGETS: 'affiliateLinkTargets',
  PARTNER_RAFFLES: 'partnerRaffles',
}
